<!-- 精品果园 -->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <div class="site-content-page">
      <div class="content-row">
        <div class="content-col">
          <image-slide title="精品果园" label="FINE ORCHARD" :showTitle="true" :infoBlock='infoBlock1' :infoList="infoList1" count="6" col="3" warpH="400px"  v-on:queryPage="jpgy_Req"/>
        </div>
      </div>
    </div>
  </div>
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col">
        <image-slide title="优质基地" label="HIGH QUALITY BASE" :showTitle="true" :infoBlock='infoBlock2' :infoList='infoList2' count="5" col="5" warpH="300px"  btStyle="1"  v-on:queryPage="yzjd_Req"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoList01 from '../block/InfoList01'
import ImageSlide from '../block/ImageSlide'
import InfoBlock16 from '../block/InfoBlock16'
import InfoBlock17 from '../block/InfoBlock17'
export default {
  name: 'Jpgy01',
  components: {
    'image-slide':ImageSlide,
  },
  data() {
    return {
      msg: '',
      infoBlock1:InfoBlock16,
      infoBlock2:InfoBlock17,
      infoList1:[],
      infoList2:[]
    }
  },
  methods:{
      //精品果园
      jpgy_Req(params){
            let that=this;
            params.type=that.tabDefaultType;
            let result={page:params};
            params.pageSize=14;
            that.$dataApi.orchardLists(params).then(res =>{
            console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            that.infoList1= res.data.list;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
      },
      //优质基地
      yzjd_Req(params){
            let that=this;
            params.type=that.tabDefaultType;
            let result={page:params};
            params.pageSize=21;
            //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
            that.$dataApi.orchardLists(params).then(res =>{
            //console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            that.infoList2= res.data.list;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}

.page-back-style{
  background-image:url(./../../assets/jpgy_back.jpeg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position:0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Jpgy01.vue